import { useSyncExternalStore } from 'react';

/** Follow the system preference, including changes made while the app is open. */
function subscribe(listener: () => void): () => void {
  const media = window.matchMedia?.('(prefers-reduced-motion: reduce)');
  media?.addEventListener?.('change', listener);
  return () => media?.removeEventListener?.('change', listener);
}

/** Shared motion preference without a second application setting. */
export function useReducedMotion(): boolean {
  return useSyncExternalStore(subscribe, () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false, () => false);
}
